const createClassNamesFromStyles = (styles) => {
  return (classNames) => classNames.map((className) => `${styles[className]}`).join(' ');
};

export default createClassNamesFromStyles;
